module.exports = __webpack_public_path__ + "static/media/suspect.c171e3bc.svg";